import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import WithRender from './RenewRequest.html';
import { Inject } from 'vue-di-container';
import { RenewRequestModel } from './RenewRequestModel';
import ValidationService from '../../Services/ValidationService';
import { SenderType } from '../../shared/Enums/SenderType';
import { DropdownModel } from '../Provider/ProviderModel';
import { SenderModel } from '../Senders/SenderModel';
import { Toaster } from '../../Services/toast';
import RenewRequestService from './RenewRequestService';
import EditSenderService from '../Senders/EditSender/EditSenderService';


@WithRender
@Component({
    components: {
    },
    diProvide: [
        EditSenderService,
        RenewRequestService,
    ],
})
export default class RenewRequest extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(EditSenderService) public editSenderService!: EditSenderService;
    @Inject(RenewRequestService) public renewRequestService!: RenewRequestService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: 0 })
    public id!: string;
    public typeFile: number = 0;
    public senderNameLength: number = 11;
    public senderType: SenderType[] = [];
    public enterpriseUnifiedNumberDisabled: boolean = true;
    public renewRequestDialog: boolean = false;
    public extendRequestDialog: boolean = false;
    public customerTypeList: DropdownModel[] = [
        {
            id: 1,
            name: this.$t('shared.government').toString(),
        },
        {
            id: 2,
            name: this.$t('shared.charity').toString(),
        },
        {
            id: 3,
            name: this.$t('shared.private').toString(),
        },
        {
            id: 4,
            name: this.$t('shared.international').toString(),
        },
    ];
    public senderTypeList: DropdownModel[] = [
        {
            id: SenderType.Advertisement,
            name: this.$t('shared.advertisement').toString(),
        },
        {
            id: SenderType.Service,
            name: this.$t('shared.service').toString(),
        },
        {
            id: SenderType.Awareness,
            name: this.$t('shared.awareness').toString(),
        },
        {
            id: SenderType.Warning,
            name: this.$t('shared.warning').toString(),
        },
    ];
    public durationList: DropdownModel[] = [
        {
            id: 1,
            name: '1',
        },
        {
            id: 2,
            name: '2',
        },
        {
            id: 3,
            name: '3',
        },
        {
            id: 4,
            name: '4',
        },
        {
            id: 5,
            name: '5',
        },
    ];
    public model: SenderModel = {
        id: '',
        displayId: '',
        duration: '',
        senderType: 0,
        newSenderType: 0,
        senderStatus: 0,
        startDate: '',
        senderId: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        providerName: '',
        customerType: 0,
        representativeEmail: '',
        representativeMobile: '',
        representativeName: '',
        senderRequestAttachments: [],
        senderName: '',
        requestStatus: 0,
        lastRejectionReason: '',
        remainingDays: 0,
        isAlreadyExist: false,
        totalDays: 0,
        comment: '',
        isCriticalSender: false,
        tenantId: '',
        isScamSender: false,
        expiryDate: '',
        verificationType: 0,
        crExpiryDate: '',
        companyName: '',
        representativeID: '',
        tenant: '',
        isAutoSuggested: false
    };
    public renewRequestModel: RenewRequestModel = {
        id: '',
        duration: 0,
    };
    public async created() {
        this.$emit('childinit', this.layoutSup);
    }
    public async mounted() {
        const response = await this.editSenderService.get(this.id);
        if (response.isSuccess) {
            this.model = response.result;
            this.renewRequestModel.id = response.result.id;
        } else {
            Toaster.error(response.errorMessage);
        }
        this.getSenderType();
        if ((this.model.customerType === 2 || this.model.customerType === 3) &&
            this.model.enterpriseUnifiedNumber.length === 0) {
            this.enterpriseUnifiedNumberDisabled = false;
        }
    }
    public getSenderType() {
        const senderBinary = this.model.senderType;

        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }
    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }
    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1:
                return this.$t('shared.government').toString();
            case 2:
                return this.$t('shared.charity').toString();
            case 3:
                return this.$t('shared.private').toString();
            case 4:
                return this.$t('shared.international').toString();
            default:
                return '-';
        }
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public isSenderNameField(val: KeyboardEvent) {
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(val.key)) {
            val.preventDefault();
        }
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public isSenderNameFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        const pattern = /^[-a-zA-Z0-9._& ]*$/;
        if (!pattern.test(paste)) {
            ev.preventDefault();
        }
    }
    public get isValid(): boolean {
        if (this.renewRequestModel.duration.toString().trim() === ''
            || this.renewRequestModel.duration === 0) {
            return false;
        }
        return !this.exceedsMaxSenderValidityPeriod(Number(this.renewRequestModel.duration));
    }

    public get exceedsValidityPeriod(): boolean {
        if (this.renewRequestModel.duration.toString().trim() === ''
            || this.renewRequestModel.duration === 0) {
            return false;
        }
        return this.exceedsMaxSenderValidityPeriod(Number(this.renewRequestModel.duration));
    }

    private exceedsMaxSenderValidityPeriod(requestedExtendDuration: number): boolean {
        const maxSenderValidityYears = 5;
        if (this.model.startDate === null || this.model.startDate === undefined || this.model.startDate === '') {
            return false;
        }

        const startDate = new Date(this.model.startDate);
        if (isNaN(startDate.getTime())) {
            return false;
        }

        const durationYears = Number(this.model.duration);
        const durationToAdd = isNaN(durationYears) ? 0 : durationYears;

        const today = new Date();
        const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        const currentExpiryDate = new Date(
            startDate.getFullYear() + durationToAdd,
            startDate.getMonth(),
            startDate.getDate());

        const effectiveExpiryFromToday = currentExpiryDate > todayDate ? currentExpiryDate : todayDate;
        const newExpiryDate = new Date(
            effectiveExpiryFromToday.getFullYear() + requestedExtendDuration,
            effectiveExpiryFromToday.getMonth(),
            effectiveExpiryFromToday.getDate());

        const maxAllowedDate = new Date(
            todayDate.getFullYear() + maxSenderValidityYears,
            todayDate.getMonth(),
            todayDate.getDate());

        return newExpiryDate > maxAllowedDate;
    }
    public showExtendRequestDialog(id: string) {
        this.extendRequestDialog = true;
    }
    public hideExtendRequestDialog() {
        this.extendRequestDialog = false;
    }
    public PreparePay(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        }
        this.$router.push({ name: 'Payment', params: { ids: ids.join(',') } });
    }
    public async saveExtendRequest() {
        const response = await this.renewRequestService.AddExtendRequest(this.renewRequestModel);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.extendRequestedSuccessfully').toString());
            this.hideExtendRequestDialog();
            this.PreparePay(response.result)
        } else {
            Toaster.error(response.errorMessage);
            this.hideExtendRequestDialog();
            this.$router.push({ name: 'Dashboard' });
        }
    }
}
